import { UltraRouletteMultipier } from '@/models/games/ultraRoulette/Multipier';
import { UltraRouletteResult } from '@/models/games/ultraRoulette/Result';
import { getHostByGameId } from '@/modules/host/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { MultipierResultDelay } from '@/modules/rwdGame/ultraRoulette/BetArea/constants';
import store from '@/store/store';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDScUltraRouletteMultipier, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScUltraRouletteMultipierHandler extends AbstractHandler {
    _command: CMDScUltraRouletteMultipier;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScUltraRouletteMultipier;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        if (host.HostId == this._command.HostID) {
            const hostLiveData = getHostLiveDataByHostId(state, host.HostId);
            let previousDelayTime = 0;
            dispatch(
                hostLiveSliceActions.updateGameResultObject({
                    hostId: host.HostId,
                    result: Object.assign({
                        GameID: this._command.GameID,
                        FResult: hostLiveData.CurrentResult?.FResult,
                        GameCount: hostLiveData.CurrentResult?.GameCount,
                        Result: hostLiveData.CurrentResult?.Result,
                        ResultString: hostLiveData.CurrentResult?.ResultString,
                        ResultPoint: -1,
                        ResultMultipier: -1,
                        Multipier: 1,
                        Multipiers: this._command.MultiList.map(v => {
                            const delayTime = parseFloat(
                                (
                                    previousDelayTime +
                                    MultipierResultDelay[v.Number]
                                ).toFixed(2)
                            );
                            previousDelayTime = delayTime;
                            return {
                                delay_time: delayTime,
                                Multipier: v.Multipier,
                                Number: v.Number,
                            };
                        }) as Array<UltraRouletteMultipier>,
                    } as UltraRouletteResult),
                })
            );
        }
    }
}
